<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div style="text-align: center;" class="modal-title">
      {{ modalData.title }}
    </div>
    <p style="text-align: center;">"{{ modalData.workTitle }}"</p>
    <br />
    <div class="btn-wrapper">
      <div @click="ok()" class="btn">
        {{ $t('main.confirm') }}
      </div>
      <div @click="closeModal()" class="btn inv">
        {{ $t('main.cancel') }}
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'confirmModal',
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  methods: {
    ok () {
      this.modalData.ok()
      eventBus.$emit('closeModal')
    },
    closeModal () {
      if (this.modalData.cancel) {
        this.modalData.cancel()
      }
      eventBus.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/btnStyles.scss';
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import '@/assets/scss/scrollbarStyles.scss';
  @include scrollbar;
  @import '@/assets/scss/cardStyles.scss';

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
  }
}
</style>
